import {TenantDto} from "../../model/TenantDto";
import {customAxios} from "../customAxios";
import {useEffect, useRef, useState} from "react";

export function useGetTenants() {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<TenantDto[]>([]);
    const [error, setError] = useState<Error>();
    const latestRequest = useRef(0);

    useEffect(() => {
        execute().catch(() => undefined);
    }, []);
    async function execute() {
        const request = ++latestRequest.current;
        try {
            setLoading(true);
            setError(undefined);
            const data = await getTenants();
            if(request === latestRequest.current) setData(data);
            return data;
        }
        catch (e) {
            if(request === latestRequest.current) setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            if(request === latestRequest.current) setLoading(false);
        }
    }

    return {
        loading, data, error, execute
    };
}

export async function getTenants(): Promise<TenantDto[]> {
    const response = await customAxios.get<TenantDto[]>('/v1/tenant', );
    return response.data;
}
